import { Components, Theme } from '@mui/material/styles';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiAutocomplete-inputRoot': {
        padding: `${theme.spacing(5, 65, 5, 9)} !important`,
      },
      '& .MuiInputBase-input': {
        paddingLeft: `${theme.spacing(3)} !important`,
      },
    }),
    paper: {
      '&:has(.MuiAutocomplete-listbox:empty)': {
        display: 'none',
      },
    },
  },
};
